import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AppCommonModule } from 'src/app/common.module';
import { WorkMachine } from 'src/app/models/work-machine.model';
import { ContractorsService } from 'src/app/services/contractors.service';
import { CardComponent } from 'src/app/ui/card/card.component';
import { FormFieldComponent } from 'src/app/ui/form-field/form-field.component';
import { FormStackComponent } from 'src/app/ui/form-stack/form-stack.component';
import { ModalShellComponent } from 'src/app/ui/modal-shell/modal-shell.component';
import { SectionHeaderComponent } from 'src/app/ui/section-header/section-header.component';

@Component({
  selector: 'app-work-machine-dialog',
  templateUrl: './work-machine.dialog.html',
  styleUrls: ['./work-machine.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    AppCommonModule,
    ReactiveFormsModule,
    ModalShellComponent,
    CardComponent,
    SectionHeaderComponent,
    FormStackComponent,
    FormFieldComponent,
  ],
})
export class WorkMachineDialogComponent implements OnInit {
  private contractorsService = inject(ContractorsService);
  private formBuilder = inject(FormBuilder);
  private modalCtrl = inject(ModalController);

  item = input<WorkMachine>();

  formGroup: FormGroup;

  readonly periodOptions = [
    { value: 'day', labelKey: 'workMachines.day', icon: 'today-outline' },
    { value: 'week', labelKey: 'workMachines.week', icon: 'calendar-outline' },
    { value: 'month', labelKey: 'workMachines.month', icon: 'calendar-clear-outline' },
  ];

  ngOnInit(): void {
    const item = this.item();
    this.formGroup = this.formBuilder.group({
      guid: [item?.guid ?? null],
      name: [item?.name ?? null, Validators.required],
      contractor: [item?.contractor ?? this.contractorsService.contractorS()?.guid],
      cost: [item?.cost ?? null],
      period: [item?.period ?? 'day', Validators.required],
    });
  }

  setPeriod(value: string) {
    this.formGroup.get('period')?.setValue(value);
  }

  save() {
    const item: WorkMachine = this.formGroup.value;
    this.modalCtrl.dismiss(item);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
